<template>
  <div class="sticky__cta">
      <img class="left-img" src="@/assets/member/hongnvlang.png" alt="">
      <div class="center-text">
        <p class="center-text-title">免费印占书籍，专属私人解读</p>
        <p class="center-text-desc">探索吠陀业力占星、指点个人命运迷津</p>
      </div>
      <!-- <div class="right-btn" @click="copyWxChatAccount">点击领取</div> -->
      <div class="right-btn" @click="toIntroAuthor">{{ buttonText }}</div>

  </div>
</template>

<script>
export default {
  name: 'StickycCta',
  props: {
    ctaText: {
      type: String,
      default: "想要免费获取印占资料？请点击这里"
    },
    buttonText: {
      type: String,
      default: "点击领取"
    }
  },
  data() {
    return {

    };
  },

  methods: {
    toIntroAuthor() {
      this.$router.push({
        path: '/member/introAuthor',
      })
    },

    copyWxChatAccount() {
      // 模拟 输入框
      const wxChatAccount = 'Summer_Astro'
      var cInput = document.createElement("input");
      cInput.value = wxChatAccount;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本框内容
      document.execCommand("copy");
      document.body.removeChild(cInput);
      this.$notify({
        type: 'success',
        message: '你已复制成功Summer的微信号，可在微信搜索添加！' 
      });
    },
  },

  components: {},
};
</script>

<style scoped lang="less">
  .sticky__cta {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%) ;
    width: 690px;
    height: 86px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 7px 0;/*no*/
    background-image: linear-gradient(to right bottom, #DA9281, #EDA279);
    box-sizing: border-box;
    text-align: center;
    border-radius: 43px;
    z-index: 3;

    .left-img {
      width: 99px;
      height: 93px;
      /* IOS 微信星标情况下 rotateY 失效，改用 scaleX 实现镜像 */
      transform: scaleX(-1);
    }

    .center-text {
      margin-left: 10px;
      .center-text-title {
        font-weight: 600;
        font-size: 25px;
        color: #F7F4F0;
        line-height: 40px;
      }
      .center-text-desc {
        font-weight: 500;
        font-size: 20px;
        color: #090909;
        line-height: 30px;
      }
    }
    .right-btn {
      padding: 15px 30px;
      font-size: 24px;
      color: #020202;
      line-height: 30px;
      background-image: linear-gradient(to bottom, #FAD126 0%, #F87774 100%);
      border-radius: 30px;
      border: 3px solid #F7F4F0;
    }
  }
</style>
